import { Routes } from '@angular/router';

export const newsProjectsRoutes: Routes = [
    {
        path: '', loadComponent: () => import('./news-projects.component').then(m => m.NewsProjectsComponent),
        children: [
            {
                path: '', redirectTo: 'news', pathMatch: 'full',
            },
            {
                path: 'news',
                loadComponent: () => import('./news/news.component').then(m => m.NewsComponent),
            },
            {
                path: 'projects',
                loadComponent: () => import('./projects/projects.component').then(m => m.ProjectsComponent),
            }
        ]
    }
];